import * as React from 'react';
import { connect } from 'react-redux';
import { getRole } from 'utils/auth';

const CompanyLogo = ({ customer: { name: companyName, logo } = {} }) => {
  if (!logo || !logo.url) return null;

  return (
    <img
      src={logo.url}
      alt={`${companyName || 'Company'} logo`}
      height="64px"
    />
  );
};

const mapStateToProps = ({ entities }) => ({
  customer: entities.customers.data[getRole()?.customerId],
});

export default connect(mapStateToProps)(CompanyLogo);
